import { memo, useMemo } from 'react';
import { LottieGif } from '@Sage/ssm-web5';
import { Loader, Text, useTheme } from '@Sage/hoi-poi-ui';
import lottiePayment from './components/lottiePayment.json';
import PurchaseOK from './components/PurchaseOK';
import PurchaseKO from './components/PurchaseKO';

import './styles.scss';

const Status = memo(({ text, title, processing, ok, ko }) => {
    const theme = useTheme();

    const loaderContent = useMemo(() => {
        switch (true) {
            case processing:
                return <LottieGif src={lottiePayment} />;
            case ok:
                return <PurchaseOK className="fm-purchase-status__image" />;
            case ko:
                return <PurchaseKO className="fm-purchase-status__image" />;
            default:
                return <Loader />;
        }
    }, [processing, ok, ko]);

    return (
        <div className="fm-purchase-status">
            {loaderContent}
            {!!title && (
                <Text type="h6" color={theme.colors.utility.textPrimary}>
                    {title}
                </Text>
            )}
            {!!text && <Text color={theme.colors.utility.textPrimary}>{text}</Text>}
        </div>
    );
});

export default Status;
